"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK = void 0;
const ky_1 = __importDefault(require("ky"));
const mitt_1 = __importDefault(require("mitt"));
function isEmpty(obj) {
    for (const prop in obj) {
        if (obj.hasOwnProperty(prop))
            return false;
    }
    return true;
}
class SDK {
    constructor(config) {
        var _a;
        this.on = (type, handler) => {
            return this.emitter.on(type, handler);
        };
        this.off = (type, handler) => {
            return this.emitter.off(type, handler);
        };
        this.emit = (type, event) => {
            return this.emitter.emit(type, event);
        };
        /**
         * public key set in the JWKS format
         */
        this.getJwks = (params, body) => {
            const path = `.well-known/jwks.json`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("getJwksResponse");
                        }
                        else {
                            this.emitter.emit("getJwksError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * get JWT for current session
         */
        this.getJwt = (params, body) => {
            const path = `jwt`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("getJwtResponse");
                        }
                        else {
                            this.emitter.emit("getJwtError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Connect with identity provider
         */
        this.initConnect = (params, body) => {
            const path = `connect/${params.provider}/${params.override}`;
            const searchParams = Object.assign({}, "state" in params && params["state"]
                ? { state: params["state"].toString() }
                : null, "code" in params && params["code"]
                ? { code: params["code"].toString() }
                : null, "scope" in params && params["scope"]
                ? { scope: params["scope"].toString() }
                : null, "authuser" in params && params["authuser"]
                ? { authuser: params["authuser"].toString() }
                : null, "prompt" in params && params["prompt"]
                ? { prompt: params["prompt"].toString() }
                : null);
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("initConnectResponse");
                        }
                        else {
                            this.emitter.emit("initConnectError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Logout
         */
        this.logout = (params, body) => {
            const path = `logout`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("logoutResponse");
                        }
                        else {
                            this.emitter.emit("logoutError");
                        }
                    },
                ],
            };
            return this.http
                .post(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Get me
         */
        this.getMe = (params, body) => {
            const path = `me`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("getMeResponse");
                        }
                        else {
                            this.emitter.emit("getMeError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Create an account
         */
        this.createAccount = (params, body) => {
            const path = `accounts`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("createAccountResponse");
                        }
                        else {
                            this.emitter.emit("createAccountError");
                        }
                    },
                ],
            };
            return this.http
                .post(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Get an account by ID
         */
        this.getAccountById = (params, body) => {
            const path = `accounts/${params.accountId}`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("getAccountByIdResponse");
                        }
                        else {
                            this.emitter.emit("getAccountByIdError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Create a user
         */
        this.createUser = (params, body) => {
            const path = `users`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("createUserResponse");
                        }
                        else {
                            this.emitter.emit("createUserError");
                        }
                    },
                ],
            };
            return this.http
                .post(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Get a user by ID
         */
        this.getUserById = (params, body) => {
            const path = `users/${params.userId}`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("getUserByIdResponse");
                        }
                        else {
                            this.emitter.emit("getUserByIdError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Get a user profile by user ID
         */
        this.getUserProfileByUserId = (params, body) => {
            const path = `users/${params.userId}/profile`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("getUserProfileByUserIdResponse");
                        }
                        else {
                            this.emitter.emit("getUserProfileByUserIdError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Update a user profile by user ID
         */
        this.updateUserProfileByUserId = (params, body) => {
            const path = `users/${params.userId}/profile`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("updateUserProfileByUserIdResponse");
                        }
                        else {
                            this.emitter.emit("updateUserProfileByUserIdError");
                        }
                    },
                ],
            };
            return this.http
                .put(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Get tours
         */
        this.getTours = (params, body) => {
            const path = `accounts/${params.accountId}/tours`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("getToursResponse");
                        }
                        else {
                            this.emitter.emit("getToursError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Create a tour
         */
        this.createTour = (params, body) => {
            const path = `accounts/${params.accountId}/tours`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("createTourResponse");
                        }
                        else {
                            this.emitter.emit("createTourError");
                        }
                    },
                ],
            };
            return this.http
                .post(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Get tours
         */
        this.getToursAfterT = (params, body) => {
            const path = `tours`;
            const searchParams = Object.assign({}, "t" in params && params["t"] ? { t: params["t"].toString() } : null, "limit" in params && params["limit"]
                ? { limit: params["limit"].toString() }
                : null);
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("getToursAfterTResponse");
                        }
                        else {
                            this.emitter.emit("getToursAfterTError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Get a tour by ID
         */
        this.getTourById = (params, body) => {
            const path = `tours/${params.tourId}`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("getTourByIdResponse");
                        }
                        else {
                            this.emitter.emit("getTourByIdError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Create tour details
         */
        this.createTourDetails = (params, body) => {
            const path = `accounts/${params.accountId}/tours/${params.tourId}/details`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("createTourDetailsResponse");
                        }
                        else {
                            this.emitter.emit("createTourDetailsError");
                        }
                    },
                ],
            };
            return this.http
                .post(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Get tour details
         */
        this.getTourDetails = (params, body) => {
            const path = `accounts/${params.accountId}/tours/${params.tourId}/details`;
            const searchParams = Object.assign({}, "language" in params && params["language"]
                ? { language: params["language"].toString() }
                : null);
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("getTourDetailsResponse");
                        }
                        else {
                            this.emitter.emit("getTourDetailsError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Create a schedule for a tour
         */
        this.createScheduleForTour = (params, body) => {
            const path = `accounts/${params.accountId}/tour/${params.tourId}/schedules`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("createScheduleForTourResponse");
                        }
                        else {
                            this.emitter.emit("createScheduleForTourError");
                        }
                    },
                ],
            };
            return this.http
                .post(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Get schedules
         */
        this.getSchedules = (params, body) => {
            const path = `accounts/${params.accountId}/tour/${params.tourId}/schedules`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("getSchedulesResponse");
                        }
                        else {
                            this.emitter.emit("getSchedulesError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Get occurrences
         */
        this.getOccurrences = (params, body) => {
            const path = `tour/${params.tourId}/occurrences`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("getOccurrencesResponse");
                        }
                        else {
                            this.emitter.emit("getOccurrencesError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Create an availability
         */
        this.createAvailability = (params, body) => {
            const path = `accounts/${params.accountId}/tours/${params.tourId}/availabilities`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("createAvailabilityResponse");
                        }
                        else {
                            this.emitter.emit("createAvailabilityError");
                        }
                    },
                ],
            };
            return this.http
                .post(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Get availabilities
         */
        this.getAvailabilities = (params, body) => {
            const path = `accounts/${params.accountId}/tours/${params.tourId}/availabilities`;
            const searchParams = Object.assign({}, "schedule-id" in params && params["schedule-id"]
                ? { "schedule-id": params["schedule-id"].toString() }
                : null, "occurence-id" in params && params["occurence-id"]
                ? { "occurence-id": params["occurence-id"].toString() }
                : null);
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("getAvailabilitiesResponse");
                        }
                        else {
                            this.emitter.emit("getAvailabilitiesError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Create a price for a tour
         */
        this.createPriceForTour = (params, body) => {
            const path = `accounts/${params.accountId}/tours/${params.tourId}/prices`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("createPriceForTourResponse");
                        }
                        else {
                            this.emitter.emit("createPriceForTourError");
                        }
                    },
                ],
            };
            return this.http
                .post(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Create a price for a tour schedule
         */
        this.createPriceForTourSchedule = (params, body) => {
            const path = `accounts/${params.accountId}/tours/${params.tourId}/schedules/${params.scheduleId}/prices`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("createPriceForTourScheduleResponse");
                        }
                        else {
                            this.emitter.emit("createPriceForTourScheduleError");
                        }
                    },
                ],
            };
            return this.http
                .post(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Create a price for a tour occurrence
         */
        this.createPriceForTourOccurrence = (params, body) => {
            const path = `accounts/${params.accountId}/tours/${params.tourId}/occurrences/${params.occurrenceId}/prices`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("createPriceForTourOccurrenceResponse");
                        }
                        else {
                            this.emitter.emit("createPriceForTourOccurrenceError");
                        }
                    },
                ],
            };
            return this.http
                .post(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Create an upload
         */
        this.createUpload = (params, body) => {
            const path = `accounts/${params.accountId}/uploads`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("createUploadResponse");
                        }
                        else {
                            this.emitter.emit("createUploadError");
                        }
                    },
                ],
            };
            return this.http
                .post(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Create an image from an upload
         */
        this.createImage = (params, body) => {
            const path = `accounts/${params.accountId}/images`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("createImageResponse");
                        }
                        else {
                            this.emitter.emit("createImageError");
                        }
                    },
                ],
            };
            return this.http
                .post(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Update images for a tour
         */
        this.updateTourImages = (params, body) => {
            const path = `accounts/${params.accountId}/tours/${params.tourId}/images`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("updateTourImagesResponse");
                        }
                        else {
                            this.emitter.emit("updateTourImagesError");
                        }
                    },
                ],
            };
            return this.http
                .post(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Get images for a tour
         */
        this.getTourImages = (params, body) => {
            const path = `tours/${params.tourId}/images`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("getTourImagesResponse");
                        }
                        else {
                            this.emitter.emit("getTourImagesError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Get venues
         */
        this.getVenues = (params, body) => {
            const path = `accounts/${params.accountId}/venues`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("getVenuesResponse");
                        }
                        else {
                            this.emitter.emit("getVenuesError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Create a venue
         */
        this.createVenue = (params, body) => {
            const path = `accounts/${params.accountId}/venues`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("createVenueResponse");
                        }
                        else {
                            this.emitter.emit("createVenueError");
                        }
                    },
                ],
            };
            return this.http
                .post(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Get venues
         */
        this.getVenuesAfterT = (params, body) => {
            const path = `venues`;
            const searchParams = Object.assign({}, "t" in params && params["t"] ? { t: params["t"].toString() } : null, "limit" in params && params["limit"]
                ? { limit: params["limit"].toString() }
                : null);
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("getVenuesAfterTResponse");
                        }
                        else {
                            this.emitter.emit("getVenuesAfterTError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Get a venue by ID
         */
        this.getVenueById = (params, body) => {
            const path = `venues/${params.venueId}`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("getVenueByIdResponse");
                        }
                        else {
                            this.emitter.emit("getVenueByIdError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Create venue details
         */
        this.createVenueDetails = (params, body) => {
            const path = `accounts/${params.accountId}/venues/${params.venueId}/details`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("createVenueDetailsResponse");
                        }
                        else {
                            this.emitter.emit("createVenueDetailsError");
                        }
                    },
                ],
            };
            return this.http
                .post(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Get venue details
         */
        this.getVenueDetails = (params, body) => {
            const path = `accounts/${params.accountId}/venues/${params.venueId}/details`;
            const searchParams = Object.assign({}, "language" in params && params["language"]
                ? { language: params["language"].toString() }
                : null);
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("getVenueDetailsResponse");
                        }
                        else {
                            this.emitter.emit("getVenueDetailsError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Update images for a venue
         */
        this.updateVenueImages = (params, body) => {
            const path = `accounts/${params.accountId}/venues/${params.venueId}/images`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("updateVenueImagesResponse");
                        }
                        else {
                            this.emitter.emit("updateVenueImagesError");
                        }
                    },
                ],
            };
            return this.http
                .post(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Get images for a venue
         */
        this.getVenueImages = (params, body) => {
            const path = `venues/${params.venueId}/images`;
            const searchParams = {};
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("getVenueImagesResponse");
                        }
                        else {
                            this.emitter.emit("getVenueImagesError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        this.http = ky_1.default.extend({
            prefixUrl: config.baseURL,
            timeout: (_a = config.requestTimeout) !== null && _a !== void 0 ? _a : false,
            headers: config.headers,
        });
        this.emitter = (0, mitt_1.default)();
        this.config = config;
    }
    get all() {
        return this.emitter.all;
    }
}
exports.SDK = SDK;
